// Message rating on assistant messages — ports reactions.js, reduced to a
// thumbs up / down rating (no ❤️/😂/😮/😢 reactions). Selected rating shows as an
// always-visible badge (.reactions-display); the picker (.reactions-picker,
// global class) is hidden until the message is hovered (opacity bridge lives in
// Message.module.css). Client-side only.

import { useMessagingStore } from '../../store/messagingStore'
import styles from './Reactions.module.css'

// Thumbs up / down only.
const AVAILABLE = ['👍', '👎']

interface ReactionsProps {
  index: number
  reactions?: string[]
}

export default function Reactions({ index, reactions = [] }: ReactionsProps) {
  const setRating = useMessagingStore((s) => s.setRating)

  return (
    <div className={styles.container}>
      {reactions.length > 0 && (
        <div className={styles.display}>
          {reactions.map((emoji) => (
            <button key={emoji} className={`${styles.badge} ${styles.active}`} onClick={() => setRating(index, emoji)}>
              {emoji}
            </button>
          ))}
        </div>
      )}
      <div className={`${styles.picker} reactions-picker`}>
        {AVAILABLE.map((emoji) => (
          <button
            key={emoji}
            className={`${styles.btn} ${reactions.includes(emoji) ? styles.active : ''}`}
            onClick={() => setRating(index, emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  )
}
